import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { Sun, Moon } from 'lucide-react'
import { useAppSelector, useAppDispatch } from '../../store'
import { setTheme } from '../../store/features/theme/themeSlice'

const ThemeToggle: React.FC = () => {
  const dispatch = useAppDispatch()
  const { theme } = useAppSelector((state) => state.theme)

  // 初始化主题
  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [theme])

  const handleToggle = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light'
    dispatch(setTheme(newTheme))
  }

  return (
    <motion.button
      onClick={handleToggle}
      className="p-2 rounded-lg hover:bg-gray-200 transition-colors duration-200"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      title={theme === 'light' ? '切换到夜间模式' : '切换到日间模式'}
    >
      <motion.div
        key={theme}
        initial={{ rotate: 0, scale: 0.8 }}
        animate={{ rotate: theme === 'dark' ? 180 : 0, scale: 1 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        {theme === 'light' ? (
          <Sun className="w-5 h-5" />
        ) : (
          <Moon className="w-5 h-5" />
        )}
      </motion.div>
    </motion.button>
  )
}

export default ThemeToggle